import { render, staticRenderFns } from "./SelectSpace.vue?vue&type=template&id=9e573ebe&"
import script from "./SelectSpace.vue?vue&type=script&lang=ts&"
export * from "./SelectSpace.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports